// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"687":"common/components/UploadSharedFileModal","778":"forum/components/DisplayNameModal","990":"forum/components/UploadsUserPage"}[chunkId] + ".js";
};